/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from "classnames";
import SliderV2 from "component/design-system/carousel/SliderV2";
import {
  useEffect,
  useImperativeHandle, useState,
} from "react";
import { ReactImageTurntable } from "react-image-turntable";
import canUseWebpImage from "util/helper/canUseWebpImage";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { getProductImage } from "../../../../util/helper/getProductImage";
import { getSpinningImageIdx } from "./image-helper";
import ProductImage from "./ProductImage";
import styles from "./styles.module.scss";

const SliderMainImage = ({ forwardedRef, ...props }) => {
  const {
    productImages,
    productImagesV2,
    dim,
    imageTitle,
    isPopUp = false,
    isDesktop,
    afterChange,
    onArrowClick,
    getProductImagePath = getProductImage,
    isFluidWidth,
    zoomImagePosition,
    showDots = false,
    spinningImage,
    isHovered,
    fromSideMenu,
    imageSize,
    isWebpImage,
    handleDotClick,
    handleImageClick,
    largeImage,
    showArrows = true,
    videosCount,
  } = props;

  const productImagesArr = isWebpImage && productImagesV2.length > 0 ? productImagesV2 : productImages;
  const productImageUrls = (productImagesArr.find((_: any) => _.type === "SINGLE_IMAGE")?.urls || []).filter((_: any) => _ !== "");
  let allProductImages = productImageUrls.map((image: string) => ({ img: image, zoomImg: image }));
  if (spinningImage.type === "SPINNING_IMAGE") {
    const spinningImageIdx = getSpinningImageIdx(isDesktop, allProductImages.length, videosCount);
    allProductImages = [...allProductImages.slice(0, spinningImageIdx), spinningImage, ...allProductImages.slice(spinningImageIdx)];
  }

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [zoomImagePlacement, setZoomImagePlacement] = useState("over");

  useEffect(() => {
    if (zoomImagePosition) {
      setZoomImagePlacement(zoomImagePosition);
    } else {
      setZoomImagePlacement(isDesktop ? "beside" : "over");
    }
  }, [isDesktop, zoomImagePosition]);

  useImperativeHandle(forwardedRef, () => ({
    setImage(index) {
      setCurrentImageIndex(index);
    },

  }));

  function handleSliderArrowClick(index) {
    setCurrentImageIndex(index);
    onArrowClick(index);
  }

  const maxWidth = 0.6 * (typeof window !== "undefined" ? window.screen.width : 500);
  const initialImagePath = canUseWebpImage() ? "/img/zdb" : "/product-images";

  return (
    <div>
      <SliderV2
        showDots={showDots}
        currentImageIndex={currentImageIndex}
        ulClassName={styles.product_slider}
        onArrowClick={handleSliderArrowClick}
        onDotClick={(index) => {
          setCurrentImageIndex(index);
          handleDotClick(index);
        }}
        showArrowOnHover
        handleImageClick={handleImageClick}
        showArrows={showArrows}
      >
        {allProductImages.map((imageObj: any, index: any) => {
          if (imageObj.type === "SPINNING_IMAGE") {
            // current image index condition for dynamic loading
            if (currentImageIndex === index) {
              return (
                <div
                  key={index}
                  onClick={handleImageClick}
                  className="pointer"
                >
                  <ReactImageTurntable
                    images={spinningImage.urls.map((el: string) => getRelativeImagePath(`${initialImagePath}/${el}`))}
                    // initialImageIndex={currIdx}
                    // autoRotate={{ disabled: true }}
                  />
                </div>
              );
            }
            return null;
          }

          // load only first two images, rest of the images will be loaded when user hovers on product image section
          if (index >= 2 && currentImageIndex !== index && !isHovered) {
            return null;
          }
          // return <img key={imageObj.img} src={imageObj.img} style={{ width: "100%", height: "auto" }} />;
          // return <Image key={index} src={imageObj.img} width={300} height={200} unoptimized />;
          // return null;
          // **********

          return (
            <ProductImage
              key={index}
              imageObj={imageObj}
              zoomImagePlacement={zoomImagePlacement}
              index={index}
              maxWidth={maxWidth}
              maxHeight={dim.imgHeight}
              imageSize={imageSize}
              imageTitle={imageTitle}
              isWebpImage={isWebpImage}
              getProductImagePath={getProductImagePath}
              largeImage={largeImage}
            />
          );
        })}
      </SliderV2>
      <div className={classNames(styles.styled_zoom_image, {
        [styles.side_menu_zoom]: fromSideMenu,
      })}
      >
        <div id="portal" className="portal" />
      </div>
    </div>
  );
};

SliderMainImage.displayName = "SliderMainImage";
export default SliderMainImage;
